import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
} from "@mui/material";
import {
  useDeleteTaxMutation,
  useGetTaxQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import { ITaxes, IUserAdmin } from "../../../Api/Interface/api.interface";
import NewPopUpTax from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx/CustomCheckbox";
import Pagination from "../../../Components/Pagination";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import useIsMobile from "../../../Core/hook/useIsMobile";
import dayjs, { Dayjs } from "dayjs";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedCoursing, setSelectedCoursing] = useState<ITaxes | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ITaxes | null>(null);

  const { data, isLoading, isError, refetch } = useGetTaxQuery({
    searchText: currentSearchQuery,
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (coursing: ITaxes) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: ITaxes) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const [deleteCategory] = useDeleteTaxMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the tax");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the tax");
    }
  };

  if (isLoading || userIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: ITaxes[] = Array.isArray(data?.data)
    ? (data?.data as ITaxes[])
    : [];

  const handleAddProductClick = () => {
    navigate("/tax/create");
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Name & Code .."
                className={classes.searchTextField}
                size="small"
              />
            </Grid>

            <Grid item>
              <Link to={`/tax/create`} className={classes.iconLinkPropNormal}>
                <Button
                  // variant="contained"
                  className={classes.addNewButton}
                  onClick={handleAddProductClick}
                >
                  Add New
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Name / Code</strong>
                </TableCell>
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Type</strong>
                  </TableCell>
                )}
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Apply To</strong>
                  </TableCell>
                )}
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Percentage</strong>
                  </TableCell>
                )}
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Create By</strong>
                  </TableCell>
                )}
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="10vh"
                    >
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: ITaxes, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {toProperCase(row.taxName)}{" "}
                        {row.taxCode ? ` / ${row.taxCode}` : ""}
                        {isMobileRes && (
                          <>
                            {row.taxType && (
                              <Typography className={classes.mobileListText}>
                                {`Type : ${row.taxType}`}
                              </Typography>
                            )}
                            {row.applyTo && (
                              <Typography className={classes.mobileListText}>
                                {`Apply To : ${row.applyTo}`}
                              </Typography>
                            )}
                            {row.percentage && (
                              <Typography className={classes.mobileListText}>
                                {`Percentage : ${
                                  row.percentage ? `${row.percentage} %` : ""
                                }`}
                              </Typography>
                            )}
                          </>
                        )}
                      </TableCell>
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          {row.taxType}
                        </TableCell>
                      )}
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          {row.applyTo}
                        </TableCell>
                      )}
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          {row.percentage ? `${row.percentage} %` : ""}
                        </TableCell>
                      )}

                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          <Typography>
                            {userMap.get(row.created_by) || ""}
                          </Typography>
                          <Typography>
                            {dayjs(row.created_at).format(
                              "MMM D, YYYY hh:mm A"
                            )}
                          </Typography>
                        </TableCell>
                      )}

                      <TableCell className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>
        {selectedCoursing && (
          <NewPopUpTax
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Tax"
            content={`Are you sure you want to delete "${coursingToDelete.taxName}"?`}
          />
        )}
      </Grid>
    </Card>
  );
};

export default Index;
